import { render, staticRenderFns } from "./WebhookResponses.vue?vue&type=template&id=4957fecf"
import script from "./WebhookResponses.vue?vue&type=script&lang=js"
export * from "./WebhookResponses.vue?vue&type=script&lang=js"
import style0 from "./WebhookResponses.vue?vue&type=style&index=0&id=4957fecf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports